const initialState = {
    crew_types: null,
    insurance_type: null,
    vehicle_types: null,
    vehicle_makes: null,
    industry_type: null,
    language: null,
}

export default function crew(state = initialState, action) {
    switch (action.type) {
        case 'LOAD_CREW_TYPES_SUCCESS':
            return {
                ...state,
                crew_types: action.data,
            }
        case 'LOAD_CREW_TYPES_ERROR':
            return {
                ...state,
                crew_types: null,
            }

        case 'LOAD_INSURANCE_TYPES_SUCCESS':
            return {
                ...state,
                insurance_type: action.data,
            }
        case 'LOAD_INSURANCE_TYPES_ERROR':
            return {
                ...state,
                insurance_type: null,
            }

        case 'LOAD_VEHICLE_TYPES_SUCCESS':
            return {
                ...state,
                vehicle_types: action.data,
            }
        case 'LOAD_VEHICLE_TYPES_ERROR':
            return {
                ...state,
                vehicle_types: null,
            }

        case 'LOAD_VEHICLE_MAKES_SUCCESS':
            return {
                ...state,
                vehicle_makes: action.data,
            }
        case 'LOAD_VEHICLE_MAKES_ERROR':
            return {
                ...state,
                vehicle_makes: null,
            }

        case 'LOAD_INDUSTRY_TYPES_SUCCESS':
            return {
                ...state,
                industry_type: action.data,
            }
        case 'LOAD_INDUSTRY_TYPES_ERROR':
            return {
                ...state,
                industry_type: null,
            }

        case 'LOAD_LANGUAGES_SUCCESS':
            return {
                ...state,
                language: action.data,
            }
        case 'LOAD_LANGUAGES_ERROR':
            return {
                ...state,
                language: null,
            }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./app/reducers/crew.js